module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesElegant@2x.a8c7f1d.jpg";